<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col  cols="12">
          <b-card>
            <div slot="header" >
              <strong>Student's Course Withdraw</strong>
            </div>

            <div class="wapper_header">
              <div class="text-center mb-2">
                <img src="../../../../public/img/logo-mfu.png" alt="" height="100px" class="mb-1">
                <p>{{this.title}}</p>
              </div>
            </div>



            <b-table class="table-outline" responsive="sm":items="tableItems" :fields="tableFields" head-variant="light">
              <div slot="id" slot-scope="item" @click="onSelect(item)">
                {{item.index+1}}
              </div>

              <div slot="action" slot-scope="item">

                <!--<b-button size="gl" variant="primary" class="mr-sm-1"><i class="fa fa-dot-circle-o"></i> Submit</b-button>-->
                <!--<b-button size="gl" variant="danger" ><i class="fa fa-clipboard"></i> Reset</b-button>-->
                <i v-b-tooltip.hover title="Detail" class="fa icon-notebook font-2xl p-1" @click="onOpenItemDetail(item)"></i>
                <i v-b-tooltip.hover title="Wait" class="fa icon-pencil font-2xl p-1" @click="onOpenItemDetail(item)"></i>
                <i v-b-tooltip.hover title="DisApproved" class="fa icon-ban font-2xl p-1" @click="onOpenItemDetail(item)"></i>
                <i v-b-tooltip.hover title="Approved" class="fa icon-check font-2xl p-1" @click="onOpenItemDetail(item)"></i>

                <!--<b-form-input id="reason" type="text" autocomplete="reason"  @change="signalChange(item,$event)" ></b-form-input>-->
              </div>
            </b-table>

            <!--<div slot="footer" class="text-right">-->
              <!--<b-button size="gl" variant="primary" @click="this.createData" class="mr-sm-1"><i class="fa fa-dot-circle-o"></i> Submit</b-button>-->
              <!--<b-button size="gl" variant="danger" @click="this.clearData"><i class="fa fa-ban"></i> Reset</b-button>-->
            <!--</div>-->

          </b-card>

        </b-col>

        <b-col cols="12" v-if="tableItems_Detail.length">
          <b-card>

            <div slot="header" >
              <strong>List Student</strong>
            </div>
            <b-table class="table-outline" responsive="sm":items="tableItems_Detail" :fields="tableFields_Detail" head-variant="light">
              <div slot="id" slot-scope="item" @click="onSelect(item)">
                {{item.index+1}}
              </div>
              <div slot="STATUS" slot-scope="item" >
                <b-form-select id="basicSelect"
                                @change="changeSelect(item,$event)"
                               :plain="true"
                               :options="itemStatus"
                               :value="item.item.INSTRUCTOR_STATUS">
                  <template v-slot:first>
                    <option :value="null" disabled>-- Please select an option --</option>
                  </template>

                </b-form-select>
              </div>
              <div slot="INSTRUCTOR_COMMENT" slot-scope="item">
                <b-form-input type="text" id="name" placeholder="Enter your comment" autocomplete="INSTRUCTOR_COMMENT" v-model="item.item.INSTRUCTOR_COMMENT"  @change="signalChange(item,$event)"></b-form-input>
              </div>
              <div slot="action" slot-scope="item">
                <i class="fa fa-save font-2xl p-1" @click="onOpenItemSave(item)"></i>
              </div>
            </b-table>
            <div slot="footer" class="text-right">
              <b-button size="gl" variant="primary"  @click="primaryModal = true" class="mr-sm-1"><i class="fa fa-dot-circle-o"></i> Confirm All</b-button>
              <!--<b-button size="gl" variant="danger" @click="this.clearData"><i class="fa fa-ban"></i> Reset</b-button>-->
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-modal
        title="Confirm Detail"
        header-bg-variant="primary"
        v-model="primaryModal"
        @ok="onConfirmAll()">

        <b-form-group
          label="Select"
          label-for="basicSelect"
          :label-cols="3">
          <b-form-select id="basicSelect"
                         @change="changeSelectAll($event)"
                         :plain="true"
                         :options="itemStatus"
                         :value="null">
            <template v-slot:first>
              <option :value="null" disabled>-- Please select an option --</option>
            </template>
          </b-form-select>
        </b-form-group>
        <b-form-group
          label="Commment"
          label-for="commment"
          :label-cols="3">
          <b-form-input id="comment" type="text" placeholder="Enter your comment" autocomplete="comment" v-model="comment"></b-form-input>
        </b-form-group>
      </b-modal>

      <b-modal
        ok-only
        :ok-variant="this.dialog.style"
        :header-bg-variant="this.dialog.style"
        v-model="this.dialog.status"
        @ok="onDismess()">
        {{this.dialog.message}}
      </b-modal>

    </div>
  </div>
</template>

<script>
  import Service from "../../../service/api"
  import CreateWithdrow from "../../components/CreateWithdrow.vue";
  export default {
    components: {
      Service,
      CreateWithdrow},
    name: 'Instructorwithdraw',
    data () {
      return {
        disabled: false,
        title:"DIVISION OF REGISTRAR, MAE FAH LUANG UNIVERSITY",
        primaryModal: false,
        selectAll:'',
        comment:'',
        studentInfo:{},
        itemStatus:[],
        tableFields: {
          id: {
            label: 'NO',
            class: 'text-center'
          },
          COURSECODE: {
            label: 'Course Code',
            class: 'text-center'
          },
          COURSENAMEENG: {
            label: 'Course Title',
            class: 'text-left'
          },
          SECTION: {
            label: 'Section',
            class: 'text-center'
          },
          CREDITTOTAL: {
            label: 'Credit',
            class: 'text-center'
          },
          ENROLLSEAT: {
            label: 'Enroll Amount',
            class: 'text-center'
          },
          WITHDRAW_AMOUNT: {
            label: 'Withdraw Amount',
            class: 'text-center'
          },
//          APPROVEDISAPP_AMOUNT: {
//            label: 'Apprved Amount',
//            class: 'text-center'
//          },
          action: {
            label: 'Detail',
            class: 'text-center'
          },
        },
        tableFields_Detail: {
          id: {
            label: 'NO',
            class: 'text-center'
          },
          STUDENTCODE: {
            label: 'Student Code',
            class: 'text-center'
          },
          REASON: {
            label: 'Reason',
            class: 'text-left'
          },
          STATUS: {
            label: 'Status',
            class: 'text-center'
          },
          INSTRUCTOR_COMMENT: {
            label: 'Comment',
            class: 'text-center'
          },
          action: {
            label: 'Action',
            class: 'text-center'
          }
        },
        tableItems:[],
        tableItems_Detail: [],
        dialog:{
          title:"Notification Infomations",
          style:"primary",
          status:false,
          message:"sadasd"

        },
        classid : '',
        section : '',
        courseid : '',
      }
    },

    methods: {

//      onOpen () {
//        this.$refs.tooltip.$emit('open')
//      },
//      onClose () {
//        this.$refs.tooltip.$emit('close')
//      },
//      disableByRef () {
//        if (this.disabled) {
//          this.$refs.tooltip2.$emit('enable')
//        } else {
//          this.$refs.tooltip2.$emit('disable')
//        }
//      },

      onLoad(){
        Service.onResultHistory("").then((response) => {
          this.tableItems = response.data.data
        }).catch((error) => {
        });
      },

      onLoadStatus(){
        Service.onGetStatus().then((response) => {
//          this.tableItems = response.data.data
          for(var i=0; i<response.data.data.length; i++){
            var item = {};
            item.text = response.data.data[i].CODENAME;
            item.value = response.data.data[i].CODE;
            this.itemStatus.push(item);

          }
        }).catch((error) => {
        });
      },

      onOpenItemDetail(item){
        this.classid = item.item.CLASSID;
        this.section = item.item.SECTION;
        this.courseid = item.item.COURSEID;
        this.onloadCourseId();
      },

      onloadCourseId(){

        var body = {};
        body.officerstatus = "";
        body.classid = this.classid;
        body.section =  this.section;
        body.courseid = this.courseid;

        Service.onResultHistoryDetail(body).then((response) => {
          this.tableItems_Detail = response.data.data
        }).catch((error) => {

        });
      },

      signalChange: function(item,evt) {
        for(var i=0; i<this.tableItems.length; i++){
          if(this.tableItems_Detail[i].WITHDRAWID == item.item.WITHDRAWID){

            this.tableItems_Detail[i].INSTRUCTOR_COMMENT = evt
//
          }
        }
      },

      changeSelect: function(item,evt) {
        for(var i=0; i<this.tableItems.length; i++){
          if(this.tableItems_Detail[i].WITHDRAWID == item.item.WITHDRAWID){
            this.tableItems_Detail[i].INSTRUCTOR_STATUS = evt
          }
        }
      },

      changeSelectAll: function(evt) {
        this.selectAll = evt;
      },

      onConfirmAll(){
        this.primaryModal = false;
        var body = {};
        var data = [];

        for(var i=0;i<this.tableItems_Detail.length;i++){
          var info = this.tableItems_Detail[i];

          var items = {};
          items.wid = info.WITHDRAWID;
          items.approvestatus = this.selectAll;
          items.comments = this.comment;
          data.push(items);
        }
        body.data = data;
        this.onUpdateInfomation(body);

      },

      onOpenItemSave(item){
        console.log(item);
        if(item.item.INSTRUCTOR_STATUS != "" && item.item.INSTRUCTOR_COMMENT != null) {
          var body = {};
          var data = [];
          var items = {};
          items.wid = item.item.WITHDRAWID;
          items.approvestatus = item.item.INSTRUCTOR_STATUS;
          items.comments = item.item.INSTRUCTOR_COMMENT;
          data.push(items);
          body.data = data;
          this.onUpdateInfomation(body);
        }else{
          this.dialog = {
            title:"Notification Infomations",
            style:"danger",
            status:true,
            message:"Please check the information."
          }
        }



      },

      onUpdateInfomation(body){
        console.log(body)
        Service.onUpdateStatus_Instructr(body).then((response) => {
          console.log(response.data)

          if(response.data.code == 200){
            this.dialog = {
              title:"Notification Infomations",
              style:"primary",
              status:true,
              message:response.data.message
            },
              this.selectAll = '';
            this.comment = '';
            this.onLoad();
            this.onloadCourseId();

          }else{
            this.dialog = {
              title:"Notification Infomations",
              style:"danger",
              status:true,
              message:response.data.message
            }
          }
        }).catch((error) => {

        });
      },

      onDismess(){


        this.dialog = {
            title:"",
            style:"primary",
            status:false,
            message:""

        }
      }

    },
    mounted() {

      this.onLoad();
      this.onLoadStatus();

    },
    created () {
    },
  }


</script>
<style>
  .line-container .item-symbol {
    box-sizing: border-box;
    position: absolute;
    left: -1.75rem;
    z-index: 1;
    background: white;
  }
</style>
